import type { ResourceDefinition } from '@/authorization/types';

export const permissionActionOrder = [
  'read',
  'create',
  'update',
  'delete',
  'admin',
] as const;

export const resourceRegistry: ResourceDefinition[] = [
  {
    key: 'products',
    labelKey: 'products',
    descriptionKey: 'products',
    supportedActions: ['read', 'create', 'update', 'delete', 'admin'],
    requiredPermissionForNavigation: 'PRODUCT_VIEW',
  },
  {
    key: 'productMenuConfiguration',
    labelKey: 'productMenus',
    descriptionKey: 'productMenus',
    supportedActions: ['read', 'create', 'update', 'delete', 'admin'],
    requiredPermissionForNavigation: 'PRODUCT_VIEW',
  },
  {
    key: 'notifications',
    labelKey: 'notifications',
    descriptionKey: 'notifications',
    supportedActions: ['read', 'create', 'update', 'delete', 'admin'],
    requiredPermissionForNavigation: 'NOTIFICATIONS_VIEW',
  },
  {
    key: 'embeddedApplications',
    labelKey: 'embeddedPortalLabel',
    descriptionKey: 'embeddedPortalLabel',
    supportedActions: ['read', 'create', 'update', 'delete', 'admin'],
    requiredPermissionForNavigation: 'EMBEDDED_APPLICATIONS_VIEW',
  },
];
